import {useState, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {setBitcoinProfit} from '../../reducers/app/actions';
import Selector from '../../selectors/modals/bitcoin_profit';
import {useNavigate} from 'react-router-dom';

const names = {
    cashapp: "CashApp",
    paypal: "PayPal"
}

const videos = {
    cashapp: "https://www.youtube.com/watch?v=fDjDH_WAvYI",
    paypal: "https://youtu.be/BE1lNXd6x4w?si=6xFe5ItS8bRWRF3i"
}

export default () => {
    const dispatch = useDispatch(),
          navigate = useNavigate(),
          [close, setClose] = useState(false),
          {bitcoin_profit} = useSelector(Selector);
    
    const blur = useRef(),
          modal = useRef();

    const closeHandler = () => {
        if(close)
            return;

        setClose(true);

        if(blur.current) {
            blur.current.classList.remove('animate__animated');
            blur.current.classList.remove('animate__fadeIn');
            blur.current.classList.add('animate__fadeOut');
            blur.current.classList.add('animate__animated');
        }

        if(modal.current) {
            modal.current.classList.remove('animate__animated');
            modal.current.classList.remove('animate__fadeInUp');
            modal.current.classList.add('animate__fadeOutDown');
            modal.current.classList.add('animate__animated');
        }

        setTimeout(() => {
            dispatch(setBitcoinProfit(null));
            setClose(false);
        }, 1e3);
    }

    if(!bitcoin_profit)
        return <></>;

    return (
        <>
            <div className="blur animate__animated animate__fadeIn" ref={blur} onClick={e => closeHandler()}></div>
            <div className="modal modal-bitcoin animate__animated animate__fadeInUp" ref={modal}>
                <div className="modal-header">
                    <div className="close" onClick={e => closeHandler()}>
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="40" height="40" rx="20" fill="#1E1F1F"/>
                            <path d="M15 25.8483L25.8483 15" stroke="#DFDFEC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M25.8483 25.8483L15 15" stroke="#DFDFEC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                </div>

               <div className="modal-body">
                    <div className="title">Are you sure?</div>
                    <div className="text">Make instant deposits via Bitcoin and get great bonuses!</div>
                    <div className="example" onClick={e => {
                        closeHandler()
                        
                        try {
                            bitcoin_profit.onClick();
                        } catch(e) {

                        }
                    }}>
                        <div className="percent">
                            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M7.52904 3.98742L4.99987 1.45825L2.4707 3.98742" stroke="#0B0B0B" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M5 8.54155V1.52905" stroke="#0B0B0B" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            15%
                        </div>
                        <div className="profit">
                            <div className="desc">Profitable with <b>Bitcoin</b></div>
                            <div className="arrow">
                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6.75012 3.05994L11.6401 7.94994C12.2176 8.52744 12.2176 9.47244 11.6401 10.0499L6.75012 14.9399" stroke="#0B0B0B" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </div>
                            <div className="amount">
                                <span>$</span> {parseFloat((bitcoin_profit.amount * 1.15).toFixed(2))}
                            </div>
                        </div>
                    </div>

                    <div className="howtobuy" onClick={() => window.open(videos[bitcoin_profit.method])}>
                        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_663_553)">
                                <rect x="6.89648" y="6.03442" width="12.931" height="12.069" fill="white"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M9.91875 15.7655L9.91797 8.69145L16.6727 12.2407L9.91875 15.7655ZM24.75 7.46563C24.75 7.46563 24.5055 5.73076 23.7562 4.96678C22.8055 3.96362 21.7398 3.95889 21.2516 3.90067C17.7531 3.64575 12.5055 3.64575 12.5055 3.64575H12.4945C12.4945 3.64575 7.24688 3.64575 3.74844 3.90067C3.25938 3.95889 2.19453 3.96362 1.24297 4.96678C0.493753 5.73076 0.249998 7.46563 0.249998 7.46563C0.249998 7.46563 0 9.50342 0 11.5404V13.4508C0 15.4886 0.249998 17.5256 0.249998 17.5256C0.249998 17.5256 0.493753 19.2604 1.24297 20.0244C2.19453 21.0276 3.44375 20.9961 4 21.1007C6 21.2943 12.5 21.3541 12.5 21.3541C12.5 21.3541 17.7531 21.3462 21.2516 21.0913C21.7398 21.0323 22.8055 21.0276 23.7562 20.0244C24.5055 19.2604 24.75 17.5256 24.75 17.5256C24.75 17.5256 25 15.4886 25 13.4508V11.5404C25 9.50342 24.75 7.46563 24.75 7.46563Z" fill="#CE1312"/>
                            </g>
                            <defs>
                                <clipPath id="clip0_663_553">
                                    <rect width="25" height="25" fill="white"/>
                                </clipPath>
                            </defs>
                        </svg>

                        How to buy and send Bitcoin with {names[bitcoin_profit.method]}
                    </div>

                    <div className="cancel" onClick={e => {
                        closeHandler()

                        try {
                            bitcoin_profit.onCancel();
                        } catch(e) {

                        }
                    }}>No thanks, continue with {names[bitcoin_profit.method]}</div>
               </div>
            </div>
        </>
    )    
}